export default {
      id: "pushpay-logo-footer-usage",
      viewBox: "0 0 1200 335.8",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo-footer",
      toString: function () {
        return this.url;
      }
    }